import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import LoggerFactory from 'live/services/logger'
import serviceLocator from 'live/services/service-locator'

import { IUpdateModeFrontPresenter, UpdateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'
import { IBarrier } from 'plugin-codaf-risk-ext-bowtie/types'

import { enUS, ptBR } from './i18n'
import { QuantitativeLopaScalingWithContribution } from './updateMode/QuantitativeLopaScalingWithContribution'

export const logger = LoggerFactory('plugin-quantitative-lopa-scaling-with-contribution-dra-engine')

const locales = { pt_br: ptBR, en_us: enUS }
i18n.add(locales[locale ?? 'en_us'])

type IUpdateModeJsonConfigConfig = {
  initialContribution: number | string
}
function requestValidationArray(barrier: IBarrier): string[] {
  const errorsArray: string[] = []

  if(!barrier.escalations.length){
      errorsArray.push(i18n("escalation factor"))
  }
  barrier.escalations.forEach((escalation, index)=>{
      const initialContribution = 
      (escalation.updateModeJsonConfig as IUpdateModeJsonConfigConfig)?.initialContribution
      if(initialContribution === null 
          || initialContribution === undefined
          || initialContribution< 0
          || initialContribution>100 ){
              errorsArray.push(`${i18n('escalation')} #${index+1} ${i18n('must have initial contribution between 0 and 1')}`)
          }
  })

  return errorsArray
}

const quantitativeLopaScalingPresenter: IUpdateModeFrontPresenter = {
  label: 'Quantitative Lopa Scaling With Contribution',
  method: 'QUANTITATIVE',
  component: QuantitativeLopaScalingWithContribution,
  updateModeCode: 'quantitative_lopa_scaling_with_contribution',
  validationFunction: requestValidationArray

}

serviceLocator.getService('dra:updatemodefrontservice').then((updateModeFrontAPI: unknown) => {
  try {
      (updateModeFrontAPI as UpdateModeFrontAPI).addUpdateModeFrontPresenter(quantitativeLopaScalingPresenter)
      logger.info('front sucesseful registered to DRA engines')
  } catch (e) {
      logger.error(e)
  }
})